export const HS_SUBHEADINGS = {
  // Carne y aves
  "020714":"Trozos y despojos de gallo/gallina, congelados","020711":"Gallo y gallinas sin trocear, congelados",
  "020712":"Pavos sin trocear, congelados","020713":"Despojos de gallo/gallina, congelados",
  // Pescado
  "030617":"Camarones y gambas congelados","030613":"Camarones y gambas frescos",
  // Lácteos
  "040210":"Leche en polvo, sin azucarar","040221":"Leche en polvo azucarada",
  "040690":"Los demás quesos","040610":"Queso fresco",
  // Café
  "090111":"Café sin tostar, sin descafeinar","090112":"Café sin tostar, descafeinado",
  "090121":"Café tostado, sin descafeinar","090122":"Café tostado, descafeinado",
  "090190":"Cáscaras, películas y desperdicios de café",
  // Aceites
  "151110":"Aceite de palma en bruto","151190":"Los demás aceites de palma",
  "151211":"Aceite de girasol en bruto","151219":"Los demás aceites de girasol",
  "150710":"Aceite de soja en bruto","150790":"Los demás aceites de soja",
  // Combustibles
  "270900":"Aceites crudos de petróleo o de mineral bituminoso",
  "271012":"Gasolinas, sin tetraetilo de plomo","271019":"Los demás aceites de petróleo",
  "271121":"Gas natural en estado gaseoso","271111":"Gas natural licuado",
  "271112":"Propano licuado","271113":"Butano licuado",
  "271091":"Desechos de aceites",
  // Químicos
  "280300":"Negro de carbono y otras formas de carbono","281410":"Amoníaco anhidro",
  "281511":"Hidróxido de sodio sólido","281512":"Hidróxido de sodio en solución acuosa",
  "283619":"Los demás carbonatos de sodio","283650":"Carbonato de calcio",
  // Farmacéuticos
  "300420":"Medicamentos con antibióticos","300431":"Medicamentos con insulina",
  "300439":"Los demás medicamentos con hormonas","300449":"Los demás medicamentos",
  "300450":"Medicamentos con vitaminas","300490":"Los demás medicamentos para uso humano",
  // Plásticos
  "390110":"Polietileno de densidad < 0.94","390120":"Polietileno de densidad ≥ 0.94",
  "390210":"Polipropileno","390230":"Copolímeros de propileno",
  "390410":"Policloruro de vinilo sin mezclar","390440":"Copolímeros de cloruro de vinilo y acetato de vinilo",
  "390760":"Poli(etileno tereftalato) - PET","390791":"Resinas alquídicas",
  "392310":"Cajas y artículos similares de plástico","392321":"Sacos y bolsas de polímeros de etileno",
  // Caucho
  "400110":"Caucho natural en hojas","400121":"Caucho natural técnicamente especificado",
  "401110":"Neumáticos de automóvil nuevos","401120":"Neumáticos de autobús o camión nuevos",
  "401130":"Neumáticos de avión nuevos","401140":"Neumáticos de motocicleta nuevos",
  // Hierro y acero
  "720810":"Laminados planos de hierro o acero, laminados en caliente",
  "720825":"Laminados planos de hierro o acero, espesor ≥ 4.75 mm",
  "721310":"Alambrón de hierro o acero con muescas","721391":"Alambrón de acero diámetro < 14 mm",
  "730410":"Tubos de línea de hierro o acero","730690":"Los demás tubos de hierro o acero",
  "731815":"Los demás tornillos y pernos","731816":"Tuercas de hierro o acero",
  // Aluminio
  "760110":"Aluminio sin alear, en bruto","760120":"Aleaciones de aluminio en bruto",
  "760612":"Chapas y tiras de aleaciones de aluminio","760611":"Chapas y tiras de aluminio sin alear",
  // Máquinas y motores
  "840710":"Motores de émbolo para aviación","840731":"Motores de émbolo cilindrada ≤ 50 cm³",
  "840734":"Motores de émbolo cilindrada > 1.000 cm³","840820":"Motores diesel para vehículos",
  "840910":"Partes para motores de aviación","840999":"Partes para motores diesel",
  "841350":"Bombas centrífugas","841360":"Las demás bombas para líquidos",
  "841430":"Compresores para equipos frigoríficos","841480":"Las demás bombas de aire o vacío",
  "841510":"Aire acondicionado de pared o ventana","841520":"Aire acondicionado para vehículos",
  "841521":"Aire acondicionado para vehículos con equipo de refrigeración",
  "841581":"Los demás aparatos de aire acondicionado","841590":"Partes para aparatos de aire acondicionado",
  "841810":"Refrigeradores-congeladores combinados","841821":"Refrigeradores domésticos de compresión",
  "841829":"Los demás refrigeradores domésticos","841850":"Los demás muebles congeladores",
  "842121":"Filtros de aire para motores de émbolo","842139":"Los demás aparatos para filtrar gases",
  "842230":"Máquinas para llenar, cerrar o etiquetar botellas",
  "843149":"Partes de grúas o máquinas de elevación","843290":"Partes de máquinas agrícolas",
  "844320":"Máquinas de imprimir por inyección de tinta","844359":"Las demás impresoras, copiadoras, fax",
  "844360":"Máquinas multifunción de impresión, copia o fax",
  "847110":"Ordenadores analógicos","847120":"Ordenadores portátiles < 10 kg",
  "847130":"Ordenadores de la unidad procesadora","847141":"Ordenadores con procesador, teclado y pantalla",
  "847149":"Las demás unidades de proceso","847150":"Unidades de proceso digitales",
  "847160":"Unidades de entrada","847170":"Unidades de almacenamiento","847180":"Las demás unidades para ordenadores",
  "847190":"Las demás máquinas automáticas de proceso de datos",
  "847310":"Partes para calculadoras","847330":"Partes y accesorios para ordenadores",
  "848210":"Cojinetes de bolas","848220":"Cojinetes de rodillos cónicos",
  "848310":"Árboles de transmisión y cigüeñales","848360":"Embragues y órganos de acoplamiento",
  "848390":"Partes de engranajes","848110":"Válvulas reductoras de presión",
  "848120":"Válvulas para transmisiones oleohidráulicas","848130":"Válvulas de retención",
  "848140":"Válvulas de seguridad o de alivio","848180":"Los demás artículos de grifería",
  // Eléctrico
  "850110":"Motores de corriente continua ≤ 37.5 W","850120":"Motores universales CA/CC",
  "850131":"Los demás motores de corriente continua","850132":"Motores de corriente continua de potencia media",
  "850161":"Generadores CA hasta 75 kVA","850162":"Generadores CA 75–375 kVA",
  "850163":"Generadores CA 375–750 kVA","850164":"Generadores CA > 750 kVA",
  "850211":"Grupos electrógenos diesel hasta 75 kVA","850212":"Grupos electrógenos diesel 75–375 kVA",
  "850213":"Grupos electrógenos diesel > 375 kVA","850220":"Grupos electrógenos con motor de gasolina",
  "850421":"Transformadores de dieléctrico líquido ≤ 650 kVA","850422":"Transformadores de dieléctrico líquido 650–10.000 kVA",
  "850423":"Transformadores de dieléctrico líquido > 10.000 kVA","850431":"Transformadores ≤ 1 kVA",
  "850432":"Transformadores 1–16 kVA","850433":"Transformadores 16–500 kVA","850434":"Transformadores > 500 kVA",
  "850440":"Convertidores estáticos","850450":"Bobinas de reactancia e inductancia",
  "850650":"Pilas y baterías de litio","850690":"Las demás pilas y baterías",
  "850710":"Acumuladores de plomo para arranque","850720":"Los demás acumuladores de plomo",
  "850730":"Acumuladores de níquel-cadmio","850750":"Acumuladores de níquel-hidruro metálico",
  "850760":"Acumuladores de iones de litio (Li-Ion)","850780":"Los demás acumuladores eléctricos",
  "851610":"Calentadores eléctricos de agua","851629":"Los demás aparatos electrotérmicos domésticos",
  "851640":"Planchas eléctricas","851650":"Hornos de microondas","851660":"Los demás hornos y cocinas eléctricas",
  "851762":"Smartphones y estaciones base para telecomunicación",
  "851769":"Módems, routers y teléfonos fijos","851770":"Partes de aparatos de telefonía",
  "851821":"Altavoces montados en su caja","851829":"Los demás altavoces",
  "851830":"Auriculares incluidos con micrófono","851840":"Amplificadores de audiofrecuencia",
  "852580":"Cámaras de televisión, digitales y videocámaras",
  "852812":"Monitores de pantalla plana","852819":"Los demás monitores",
  "852872":"Televisores en colores con receptor de radio",
  "853400":"Circuitos impresos",
  "853510":"Fusibles para tensión > 1.000 V","853521":"Seccionadores y disyuntores","853529":"Los demás interruptores AT",
  "853610":"Fusibles para tensión ≤ 1.000 V","853620":"Interruptores automáticos BT",
  "853641":"Relés","853649":"Los demás relés","853650":"Interruptores BT","853669":"Los demás aparatos de conexión",
  "853710":"Cuadros y paneles para tensión ≤ 1.000 V",
  "853921":"Lámparas de filamento de tungsteno","853931":"Lámparas fluorescentes de cátodo caliente",
  "853950":"Lámparas e instalaciones LED",
  "854121":"Transistores de potencia < 1 W","854129":"Los demás transistores",
  "854140":"Dispositivos fotosensibles; diodos LED",
  "854231":"Procesadores y controladores semiconductores","854232":"Memorias semiconductoras",
  "854233":"Amplificadores semiconductores","854239":"Los demás circuitos integrados",
  "854411":"Hilos de cobre aislados para bobinado","854419":"Los demás hilos de cobre aislados",
  "854420":"Cables coaxiales","854430":"Juegos de cables para vehículos",
  "854442":"Conductores eléctricos para tensión ≤ 1.000 V","854470":"Cables de fibras ópticas",
  // Vehículos
  "870110":"Motocultores","870120":"Tractores de carretera para semirremolques",
  "870130":"Tractores de orugas","870190":"Los demás tractores",
  "870210":"Buses con motor diesel para 10+ personas","870290":"Los demás buses y microbuses",
  "870310":"Vehículos para desplazamiento sobre nieve",
  "870321":"Automóviles de cilindrada ≤ 1.000 cm³","870322":"Automóviles de cilindrada 1.000–1.500 cm³",
  "870323":"Automóviles de cilindrada 1.500–3.000 cm³","870324":"Automóviles de cilindrada > 3.000 cm³",
  "870340":"Vehículos híbridos gasolina + eléctrico","870350":"Vehículos híbridos diésel + eléctrico",
  "870360":"Vehículos eléctricos puros","870390":"Los demás vehículos para transporte de personas",
  "870410":"Volquetes para uso fuera de carretera",
  "870421":"Camiones diesel cilindrada ≤ 5.000 cm³","870422":"Camiones diesel cilindrada > 5.000 cm³",
  "870431":"Camiones gasolina cilindrada ≤ 5.000 cm³","870432":"Camiones gasolina cilindrada > 5.000 cm³",
  "870510":"Camiones grúa","870590":"Los demás vehículos para usos especiales",
  "870600":"Chasis con motor para vehículos",
  "870710":"Carrocerías para vehículos de pasajeros","870790":"Las demás carrocerías",
  "870810":"Paragolpes y sus partes","870821":"Cinturones de seguridad","870829":"Partes de carrocería",
  "870830":"Frenos y servofrenos","870840":"Cajas de cambio","870850":"Ejes con diferencial",
  "870860":"Puentes traseros motores","870870":"Ruedas y accesorios","870880":"Sistemas de suspensión",
  "870891":"Radiadores","870892":"Silenciadores y tubos de escape","870893":"Embragues",
  "870894":"Volantes y columnas de dirección","870895":"Bolsas de aire (airbags)",
  "870899":"Las demás partes y accesorios de vehículos",
  "871141":"Motocicletas cilindrada ≤ 50 cm³","871150":"Motocicletas cilindrada > 800 cm³",
  "871200":"Bicicletas sin motor",
  // Flores y plantas
  "060311":"Rosas frescas cortadas","060312":"Claveles frescos cortados",
  "060313":"Orquídeas frescas cortadas","060314":"Crisantemos frescos cortados",
  "060319":"Las demás flores frescas cortadas","060390":"Flores y capullos secos o preservados",
  // Frutas
  "080390":"Los demás bananos frescos o secos","080440":"Aguacates frescos o secos",
  "080450":"Guayabas, mangos y mangostanes frescos","080610":"Uvas frescas",
  "080711":"Sandías frescas","080719":"Los demás melones frescos",
  "080810":"Manzanas frescas","080820":"Peras y membrillos frescos",
  "080910":"Albaricoques (damascos) frescos","080921":"Cerezas ácidas frescas",
  "080930":"Melocotones frescos","080940":"Ciruelas y endrinas frescas",
  // Instrumentos médicos
  "901831":"Jeringas con aguja","901832":"Agujas tubulares de metal",
  "901839":"Los demás artículos de inyección","901849":"Los demás aparatos de odontología",
  "901890":"Los demás instrumentos de medicina y cirugía",
  "902212":"Aparatos de tomografía computarizada","902213":"Aparatos de resonancia magnética",
  "902219":"Los demás aparatos de rayos X",
  // Muebles
  "940161":"Asientos tapizados con armazón de madera","940169":"Los demás asientos con armazón de madera",
  "940171":"Asientos tapizados con armazón de metal","940179":"Los demás asientos con armazón de metal",
  "940310":"Muebles de metal para oficinas","940320":"Los demás muebles de metal",
  "940330":"Muebles de madera para oficinas","940340":"Muebles de madera para cocinas",
  "940350":"Muebles de madera para dormitorios","940360":"Los demás muebles de madera",
  "940380":"Muebles de plástico o caucho","940390":"Partes de muebles",
  // Calzado
  "640210":"Calzado de deporte con suela de caucho o plástico",
  "640291":"Calzado de caucho o plástico que cubre el tobillo",
  "640299":"Los demás calzados de caucho o plástico",
  "640351":"Calzado con suela de caucho y parte superior de cuero, cubre tobillo",
  "640359":"Los demás calzados con parte superior de cuero",
  // Textiles
  "610910":"Camisetas de punto de algodón","620520":"Camisas de hombre de algodón",
  "611020":"Jerseys y suéters de algodón","611030":"Jerseys y suéters de fibras sintéticas",
  "620462":"Pantalones de mujer de algodón",
  // Papel
  "480100":"Papel de periódico en bobinas","480256":"Papel para impresión offset",
  "482110":"Etiquetas de papel o cartón impresas",
  // Madera
  "440320":"Madera de coníferas en bruto","440710":"Madera de coníferas aserrada",
  "441119":"Tableros de fibra de madera (MDF)",
  // Minería
  "260111":"Minerales de hierro sin aglomerar","260112":"Minerales de hierro aglomerados",
  "260200":"Minerales de manganeso","260300":"Minerales de cobre",
  "260400":"Minerales de níquel","260600":"Minerales de aluminio (bauxita)",
  "261690":"Los demás minerales de metales preciosos",
  "270112":"Hulla bituminosa","270119":"Las demás hullas","270120":"Briquetas de hulla",
};
